import api from "@/services/api";
import { ENDPOINTS_AUTH } from "@/services/endpoints";

export const loginRequest = (email, password) =>
  api.post(ENDPOINTS_AUTH.login, { email, password }).then((r) => r.data);

export const registerRequest = (payload) =>
  api.post(ENDPOINTS_AUTH.register, payload).then((r) => r.data);

export const googleRequest = (credential) =>
  api.post(ENDPOINTS_AUTH.google, { credential }).then((r) => r.data);

export const devLoginRequest = (email, name) =>
  api.post(ENDPOINTS_AUTH.devLogin, { email, name }).then((r) => r.data);

export const logoutRequest = () => api.post(ENDPOINTS_AUTH.logout).then((r) => r.data);

export const getMe = () =>
  api.get(ENDPOINTS_AUTH.me, { validateStatus: (s) => s < 500 }).then((r) => r.data);

export const lookupEmail = (email) =>
  api.get(ENDPOINTS_AUTH.lookupEmail, { params: { email } }).then((r) => r.data);

export const updateProfile = (payload) =>
  api.patch(ENDPOINTS_AUTH.me, payload).then((r) => r.data);

export const changePassword = (payload) =>
  api.post(ENDPOINTS_AUTH.changePassword, payload).then((r) => r.data);

export const twofaSetup = () => api.post(ENDPOINTS_AUTH.twofaSetup).then((r) => r.data);

export const twofaVerify = (code) =>
  api.post(ENDPOINTS_AUTH.twofaVerify, { code }).then((r) => r.data);

export const twofaDisable = () => api.post(ENDPOINTS_AUTH.twofaDisable).then((r) => r.data);

export const listSessions = () => api.get(ENDPOINTS_AUTH.sessions).then((r) => r.data);

export const logoutAll = () => api.post(ENDPOINTS_AUTH.logoutAll).then((r) => r.data);

export const updateNotificationPrefs = (payload) =>
  api.patch(ENDPOINTS_AUTH.notifications, payload).then((r) => r.data);

export const updateWorkspace = (payload) =>
  api.patch(ENDPOINTS_AUTH.workspace, payload).then((r) => r.data);

export const updateCompliance = (payload) =>
  api.patch(ENDPOINTS_AUTH.compliance, payload).then((r) => r.data);

export const exportData = () => api.get(ENDPOINTS_AUTH.export).then((r) => r.data);

export const deleteAccount = () => api.delete(ENDPOINTS_AUTH.deleteMe).then((r) => r.data);

export const getWalletNonce = () => api.get(ENDPOINTS_AUTH.walletNonce).then((r) => r.data);

export const linkWallet = (payload) =>
  api.post(ENDPOINTS_AUTH.walletLink, payload).then((r) => r.data);

export const unlinkWallet = () => api.delete(ENDPOINTS_AUTH.walletUnlink).then((r) => r.data);
